import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '../../../components/common/Button';
import Spinner from '../../../components/common/Spinner';
import { accountDetailsRequest } from '../../../modules/account/actions';
import { getCardNumber, isDetailsPending } from '../../../modules/account/selectors';
import { SETTINGS } from '../../../routes/paths';
import FormMessage from '../../FormMessage';
import { cancelCardAttempt } from './actions';

export class LostCard extends React.Component {
  constructor() {
    super();
    this.cancelHandler = this.cancelHandler.bind(this);
  }

  componentDidMount() {
    const {
      onLoad = () => {
      }
    } = this.props;

    onLoad();
  }

  cancelHandler() {
    const { history } = this.props;
    history.push(SETTINGS);
  }

  render() {
    const {
      lostCardAction,
      cardNumber,
      showSpinner
    } = this.props;

    return (
      <div className="settings">
        <div className="container--fixed">
          <FormMessage className="settings__form-message" />
        </div>
        <div className="settings__content">
          <div className="container--fixed">
            <h2 className="settings__header">Cancel and replace your William Hill Plus Card</h2>
            <p className="settings__info settings__spinner">
              {
                (showSpinner)
                  ? (<Spinner className="spinner--small" />)
                  : (cardNumber)
              }
            </p>
            <p className="settings__info">
              After cancellation, visit any William Hill shop where a colleague will issue a new Plus
              card, and your bets will be retained.
            </p>
            <Button
              className="settings__button"
              onClick={lostCardAction}
              disabled={showSpinner || !cardNumber}
            >
              Cancel Plus Card
            </Button>
            <Button
              className="settings__button button--secondary"
              onClick={this.cancelHandler}
            >
              Return to account settings
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

LostCard.propTypes = {
  lostCardAction: PropTypes.func.isRequired,
  cardNumber: PropTypes.string,
  showSpinner: PropTypes.bool,
  onLoad: PropTypes.func,
  history: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  cardNumber: getCardNumber(state),
  showSpinner: isDetailsPending(state)
});

const mapDispatchToProps = {
  lostCardAction: cancelCardAttempt,
  onLoad: accountDetailsRequest,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LostCard));
